import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { getAuthDetails } from 'globalutils/fmUtils';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const layout = window?.$environment?.CURRENT_LAYOUT;
const RadioButton = lazy(() => import(`globalcomponents/UI/Radio/${layout}`));

const Component = ({ Styled, subscriptions, subscriptionTier }) => {
  const formatString = (text) => {
    return text
      .split('_')
      .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <Styled.Wrapper>
      <Styled.TableWrapper>
        <table className="test-table">
          <thead>
            <td></td>
            {subscriptions?.subscriptionTiers?.map((subscriptionTiers) => {
              return <td>{subscriptionTiers?.displayName}</td>;
            })}
          </thead>
          <tbody>
            <tr>
              {getAuthDetails() && subscriptionTier && (
                <>
                  <td className="title">Subscriptions</td>
                  {subscriptions?.subscriptionTiers?.map((subscriptionTiers) => {
                    return (
                      <td>
                        <RadioButton disabled options={[{ value: subscriptionTiers?.name }]} value={subscriptionTier} />
                      </td>
                    );
                  })}
                </>
              )}
            </tr>
            {subscriptions &&
              subscriptions?.features &&
              Object.keys(subscriptions?.features).map((group) => {
                return (
                  <>
                    <tr>
                      <td className="title" colSpan="4">
                        {formatString(group)}
                      </td>
                    </tr>
                    {subscriptions.features[group].map((feature) => {
                      return (
                        <tr>
                          <td>{feature?.featureName}</td>
                          {Object.keys(feature.subscriptionTiers).map((tier) => (
                            <td className="icon-td">
                              {feature.subscriptionTiers[tier] ? (
                                <SvgIcon value={mediaUrls.whiteCheck} wrpClass="icon-td-svg" />
                              ) : (
                                <SvgIcon value={mediaUrls.deleteIcon} wrpClass="icon-td-svg" />
                              )}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </>
                );
              })}
          </tbody>
        </table>
      </Styled.TableWrapper>
    </Styled.Wrapper>
  );
};
export default Component;

Component.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};
